<mat-tab-group
  onsip-mat-tab-table
  (selectedIndexChange)="onSelectedIndexChange($event)"
  mat-stretch-tabs="false"
>
  <mat-tab label="Basic Settings">
    <ng-template matTabContent>
      <onsip-adv-announcements-basic-tab
        [announcement]="announcement"
        [transferToText]="transferToText"
        (mode)="mode = $event"
      >
      </onsip-adv-announcements-basic-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="Recording">
    <ng-template matTabContent>
      <onsip-adv-announcements-recording-tab
        [announcement]="announcement"
        [recording]="recording"
        [recordingArray]="recordingsArray"
        (mode)="mode = $event"
      >
      </onsip-adv-announcements-recording-tab>
    </ng-template>
  </mat-tab>
</mat-tab-group>
